module.exports = __webpack_public_path__ + "img/MATIC-logo.9729dabc.svg";